import classnames from 'classnames';
import * as React from 'react';
import { noop } from '../helper';
import { callAll } from '../helper/fp';

export type InputProps = {
  value?: string | number;
  /**
   * callback that will be invoked with the new value when value is changed.
   */
  onChangeValue?: (value: string) => void;
} & JSX.IntrinsicElements['input'];
/**
 * Input is a wrapper around `<input />` html element, thus it would accepts all props a `<input />` accepts.
 *
 * You can use `ref` to access the underlying `<input />` element
 *
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(function InputComp(
  { className, onChangeValue = noop, onChange, ...props },
  ref
) {
  return (
    <input
      className={classnames('form-control', className)}
      onChange={callAll(onChange, (ev) => onChangeValue(ev.target.value))}
      {...props}
      ref={ref}
    />
  );
});
